import React from 'react';
import { usePrivateTheme } from '@providers/privateThemeProvider';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import { themeColors } from '@theme/classNames';

const ThemeToggle = ({ showLabel }) => {
  const { isDarkMode, toggleDarkMode } = usePrivateTheme();

  return (
    <button
      type="button"
      onClick={toggleDarkMode}
      className={`p-2 rounded-lg hover:${themeColors.background.light} transition-colors ${showLabel ? 'logged-in-header__theme-toggle' : ''}`}
      aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
    >
      {isDarkMode ? (
        <SunIcon className={`h-5 w-5 ${themeColors.text.secondary}`} />
      ) : (
        <MoonIcon className={`h-5 w-5 ${themeColors.text.secondary}`} />
      )}
      {showLabel && <span>{isDarkMode ? 'Light mode' : 'Dark mode'}</span>}
    </button>
  );
};

ThemeToggle.propTypes = {
  showLabel: PropTypes.bool
};

export default ThemeToggle; 